import { always, compose, cond, identity, isNil, map, mergeAll,nth, T } from 'ramda';

export const coalesceArray = cond([
    [Array.isArray, identity],
    [isNil, always([])],
    [T, (v) => [v]],
]);

const mergeRow = (arrs) => (_, i) => compose(
    mergeAll,
    map(nth(i)),
)(arrs);

export const mergeColumns = (arrs) => {
    const [firstArr] = arrs;

    if (!firstArr){
        throw new Error('Cannot merge 0 arrays.');
    }

    if (arrs.length === 1) {
        return firstArr;
    }

    return firstArr.map(mergeRow(arrs));
};